import script from "./SampleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleCard.vue?vue&type=script&setup=true&lang=js"

import "./SampleCard.vue?vue&type=style&index=0&id=4bf4dca6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bf4dca6"]])

export default __exports__